import { createSelector } from 'reselect';

function getExperiments(state) {
  return state.experiments;
}

/**
 * @param state
 * @param experimentName
 * @returns {Boolean} Is experiment enabled
 */
export const isEnabled = createSelector(
  [
    getExperiments,
    (state, experimentName) => experimentName,
  ],
  (experiments, experimentName) => _.get(experiments, experimentName) === 'true',
);

export function isHideVideoTitleOnMainItemEnabled(state) {
  return isEnabled(state, 'hideVideoTitleOnMainItem');
}

export function isNewPlayerEnabled(state) {
  return isEnabled(state, 'newPlayer');
}

export function isNoCoverForEmbedEnabled(state) {
  return isEnabled(state, 'noCoverForEmbed');
}

export function isShoutoutEnabled(state) {
  return isEnabled(state, 'shoutout');
}

export function isVideoPreviewEnabled(state) {
  return isEnabled(state, 'videoPreview');
}

/**
 * @param state
 * @returns {String[]} Enabled experiment names list
 */
export const getEnabledExperimentsList = createSelector(
  [
    getExperiments,
  ],
  experiments =>
    _(experiments)
      .pickBy(val => val === 'true')
      .keys()
      .value(),
);



// WEBPACK FOOTER //
// ./src/shared/selectors/experiments.js